"use strict";

import template from "./template.jade";

class RegionaleEffekteBetragsrechnerController {
  /*@ngInject*/
  constructor(i18n) {
    this.gettext = i18n.gettext;
    if (!this.kontext) {
      this.kontext = "antrag";
    }
  }
}

export default {
  template: template(),
  controller: RegionaleEffekteBetragsrechnerController,
  controllerAs: "ctx",
  bindings: {
    rechner: "=",
    posmodel: "=",
    errors: "=",
    extras: "=",
    kontext: "=?",
    vorschau: "=",
    prefix: "<?"
  },
};
